var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import bugsnag from 'bugsnag-js';
import { environment } from 'environments/environment';
var CorsInterceptor = /** @class */ (function () {
    function CorsInterceptor() {
    }
    CorsInterceptor.prototype.intercept = function (req, next) {
        return next.handle(req).pipe(catchError(function (error) {
            var bugSnagClient = bugsnag({
                appVersion: environment.appVersion,
                apiKey: '4c04ddb8868eaad868b9d86299898e2d',
                releaseStage: environment.production ? 'production' : 'development'
            });
            if (error.error instanceof ProgressEvent && error.status === 0) {
                bugSnagClient.notify('CORS error detected or network issue', __assign({ severity: 'error', metaData: error, request: req }, (localStorage.getItem('userData') && { user: JSON.parse(localStorage.getItem('userData')) })));
                console.error('CORS error detected or network issue');
            }
            return throwError(error);
        }));
    };
    return CorsInterceptor;
}());
export { CorsInterceptor };
